import { isArray, isObject, isString } from 'angular';
var CompareTableCellComponentController = (function () {
    function CompareTableCellComponentController() {
        this.cellValue = '';
    }
    CompareTableCellComponentController.prototype.$onInit = function () {
        if (!this.validateBindings()) {
            this.cellValue = '&nbsp;';
        }
        else {
            var _loop_1 = function (attributeMapping) {
                var attributeValue = this_1.attributeKey + "|" + attributeMapping;
                var found = this_1.attributes.some(function (a) { return attributeValue === a; });
                if (!found) {
                    return "continue";
                }
                if (this_1.cellValue === '') {
                    this_1.cellValue = this_1.attributeMappings[attributeMapping];
                }
                else {
                    this_1.cellValue = this_1.cellValue + ", " + this_1.attributeMappings[attributeMapping];
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = Object.keys(this.attributeMappings); _i < _a.length; _i++) {
                var attributeMapping = _a[_i];
                _loop_1(attributeMapping);
            }
        }
    };
    CompareTableCellComponentController.prototype.validateBindings = function () {
        return (isArray(this.attributes) &&
            this.attributes.length > 0 &&
            (isString(this.attributeKey) && this.attributeKey !== '') &&
            (isObject(this.attributeMappings) && this.attributeMappings !== null));
    };
    return CompareTableCellComponentController;
}());
export var CompareTableCellComponent = {
    bindings: {
        attributeKey: '<',
        attributeMappings: '<',
        attributes: '<',
    },
    controller: CompareTableCellComponentController,
    template: '<span class="compare-table-cell__value" ng-bind-html="$ctrl.cellValue"></span>',
};
